import { render, staticRenderFns } from "./DealSelector.vue?vue&type=template&id=65383551&scoped=true&"
import script from "./DealSelector.vue?vue&type=script&lang=ts&"
export * from "./DealSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DealSelector.vue?vue&type=style&index=0&id=65383551&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65383551",
  null
  
)

export default component.exports